import { FormControlLabel, Switch } from '@mui/material';
import { useContext } from 'react';

import { SDKContext } from '../context/sdk';
import DesignActionButton from './DesignActionButton';
import SDKActionButton from './SDKActionButton';

const toggles: { key: string, label: string }[] = [{
  key: 'setbacks',
  label: 'Setbacks',
}, {
  key: 'measurements',
  label: 'Measurements'
}, {
  key: 'designComponents',
  label: 'Components'
}, {
  key: 'lidar',
  label: 'LIDAR'
}, {
  key: 'irradianceMap',
  label: 'Roof Irradiance'
}, {
  key: 'irradianceMapPanels',
  label: 'Panel Irradiance'
}];

export default function ToggleViewButtonsPanel() {
  const { design: designInstance, viewToggles, setViewToggles } = useContext(SDKContext); 
  return (
    <div
      style={{ padding: 0 }}
    >
      <div
        style={{
          alignItems: 'flex-end',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          flexDirection: 'column',
          margin: '0 auto',
          paddingLeft: 0,
          minHeight: '86px',
          maxWidth: '800px'
        }}
      >
        <SDKActionButton
          onClick={(sdk) => sdk.cad.toggleFullScreen()}
        >
        Toggle Full Screen
        </SDKActionButton>
        <DesignActionButton
          onClick={(design) => design.downloadScreenshot()}
        >
          Download Screenshot
        </DesignActionButton>
        {toggles?.map((toggle) => {
          if (!viewToggles) {
            return null;
          }

          const isOn = viewToggles[toggle.key];
          return (
            <FormControlLabel
              checked={isOn}
              control={
                <Switch
                  checked={isOn}
                  color="success"
                  onChange={() => {
                    if (!viewToggles) {
                      return;
                    }
                    const payload = { 
                      [toggle.key]: !isOn 
                    };

                    return designInstance.toggleView(payload).then(() => setViewToggles({
                      ...viewToggles,
                      ...payload,
                    }));
                  }}
                  sx={{
                    alignItems: 'flex-end'
                  }}
                />
              }
              label={toggle.label}
              labelPlacement="start"
              key={toggle.key}
            />
          );
        })}
      </div>
    </div>
  );
}



